import { POIShape } from './POIShape';
import * as THREE from 'three';
import { AppSettingsData } from '../core/AppSettingsData';
import { SceneSettingsData } from '../core/SceneSettingsData';
import { POI } from '../poi/POI';

export class CylinderShape extends POIShape {
    constructor(
        poi: POI,
        sceneSettings?: SceneSettingsData,
        appSettings?: AppSettingsData
    ) {
        const isCone = poi.poidata.shape.value === 'cone';
        const options = { 
            radiusTop: isCone ? 0 : 0.5, 
            radiusBottom: 0.5, 
            height: 1, 
            radialSegments: 32, 
            heightSegments: 1 
        };
        
        super(poi, sceneSettings, appSettings, options);
    }

    protected createGeometry(): THREE.BufferGeometry {
        const { radiusTop, radiusBottom, height, radialSegments, heightSegments } = this.getGeometryData();
        return new THREE.CylinderGeometry(radiusTop, radiusBottom, height, radialSegments, heightSegments);
    }

    // Convenience getters/setters
    get radiusTop(): number {
        return this.getGeometryData().radiusTop;
    }

    set radiusTop(value: number) {
        this.setGeometryData({ ...this.getGeometryData(), radiusTop: value });
    }

    get radiusBottom(): number {
        return this.getGeometryData().radiusBottom;
    }

    set radiusBottom(value: number) {
        this.setGeometryData({ ...this.getGeometryData(), radiusBottom: value });
    }

    get height(): number {
        return this.getGeometryData().height;
    }

    set height(value: number) {
        this.setGeometryData({ ...this.getGeometryData(), height: value });
    }

    get radialSegments(): number {
        return this.getGeometryData().radialSegments;
    }

    set radialSegments(value: number) {
        this.setGeometryData({ ...this.getGeometryData(), radialSegments: Math.max(3, Math.floor(value)) });
    }

    get heightSegments(): number {
        return this.getGeometryData().heightSegments;
    }

    set heightSegments(value: number) {
        this.setGeometryData({ ...this.getGeometryData(), heightSegments: Math.max(1, Math.floor(value)) });
    }

    /*
    clone(): CylinderShape {
        const clonedData = this.poidata.clone();
        return new CylinderShape(clonedData);
    }
    */
} 